import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { MediumUp, MobileOnly } from 'src/ui/block';
import { FeaturedColumns } from '../../components/price-row-columns/featured-columns';
import { UnfeaturedColumns } from '../../components/price-row-columns/unfeatured-columns';
import OptionsColumn from './options-cloumn';

import { AlternativePrice } from 'src/types';
import { ITableLinkProps } from '../../types';

import * as S from '../styles';

type Props = {
  alternativeOffer: AlternativePrice;
  priceRowRef?: React.RefObject<HTMLDivElement>;
  tableLinkProps: ITableLinkProps;
};

const AlternativePriceRow = ({
  alternativeOffer,
  priceRowRef,
  tableLinkProps,
}: Props) => {
  const { isFeatured, newOfferItemExperiment } = usePriceRowContext();
  const { externalUri } = alternativeOffer;

  return (
    <S.RowCard $expanded $featured={isFeatured} $isAlternative>
      <S.Row
        $expanded
        $featured={isFeatured}
        $isAlternative
        $newOfferItemExperiment={Boolean(newOfferItemExperiment)}
        $noExternalUri={!externalUri}
      >
        {!newOfferItemExperiment && (
          <MobileOnly>
            <OptionsColumn alternativeOffer={alternativeOffer} />
          </MobileOnly>
        )}
        <MediumUp>
          <OptionsColumn alternativeOffer={alternativeOffer} />
        </MediumUp>

        {isFeatured && alternativeOffer.externalUri && (
          <FeaturedColumns
            alternativeOffer={alternativeOffer}
            expanded
            tableLinkProps={tableLinkProps}
          />
        )}
        {(!isFeatured || !alternativeOffer.externalUri) && (
          <UnfeaturedColumns
            alternativeOffer={alternativeOffer}
            isAlternative
            priceRowRef={priceRowRef}
            tableLinkProps={tableLinkProps}
          />
        )}
      </S.Row>
    </S.RowCard>
  );
};

export default AlternativePriceRow;
